import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import styles from "../../styles/common/brsrTable.module.css";

const ReusableTable = ({
  title,
  rows,
  columns,
  onChange,
  errors,
  data,
  setRows,
  disabled,
}) => {
  const [isFilleds, setIsFilled] = useState({});
  useEffect(() => {
    const totalRows = getRowCount(data);
    console.log("Total Rows:", totalRows);
    setRows && setRows(totalRows); // Update state based on calculated row count
    console.log(errors, "errorsValue");
  }, [data, columns]);

  const getRowCount = (data) => {
    console.log(data, "data for the table");

    if (!data || typeof data !== "object") return 0; // Ensure data is an object or array

    // If data is an array, count rows for each object in the array
    if (Array.isArray(data)) {
      let totalRows = 0;
      data.forEach((table) => {
        if (table && typeof table === "object") {
          totalRows += Object.keys(table).length; // Count top-level keys
        }
      });
      return totalRows;
    }

    // If data is an object, count its top-level keys as rows
    return Object.keys(data).length;
  };

  return (
    <div>
      {title && <p style={{marginLeft:"15px"}}>{title}</p>}
      <TableContainer
        component={Paper}
        className={styles.tableContainer}
        sx={{
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          ml: 2,
          width: "98.5%",
        }}
      >
        <Table className={styles.table}>
          <TableHead>
            <TableRow className={styles.tableHeader}>
              {columns.map((col, colIndex) => (
                <TableCell
                  key={colIndex}
                  sx={{ width: col.width }}
                  className={styles.tableHeaderCell}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  border: "1px solid rgba(224, 224, 224, 1)",
                  width: row?.width || "10% ",
                }}
              >
                {columns.map((col, colIndex) => (
                  <TableCell
                    sx={{ border: "1px solid #DBDBDB" }}
                    key={colIndex}
                  >
                    {col.type === "text" ||
                    col.type === "number" ||
                    col.type === "weblink" ? (
                      <TextField
                        size="small"
                        fullWidth
                        disabled={disabled}
                        value={row[col.field] ?? ""}
                        onChange={(e) =>
                          onChange(
                            rowIndex,
                            col.type ? col.type : "text",
                            col.field,
                            e.target.value
                          )
                        }
                        minRows={1}
                        multiline
                        placeholder={
                          col?.placeholder ? col?.placeholder : "Type Here"
                        }
                        variant="standard"
                        InputProps={{
                          disableUnderline: true,
                          className: styles.textField,
                        }}
                        className={styles.textFieldContainer}
                      />
                    ) : (
                      row[col.field]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {errors &&
        Object.keys(errors).map((item) => {
          console.log(
            errors[item]?.["errorSummary"],
            errors,
            item,
            "checking error"
          );
          return (
            <Typography
              // key={item} // Add a unique key
              variant="body2"
              color="error"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                // marginTop: "10px",
                marginLeft:"15px"
              }}
            >
              {errors[item]?.["errorSummary"]}
            </Typography>
          );
        })}
    </div>
  );
};

export default ReusableTable;
